<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="设置"
    width="500px"
    
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="100px">

       


        <el-form-item label="性别" prop="sex" >  
          <el-radio-group v-model="formData.sex" size="small">
            <el-radio :label="1" border>男</el-radio>
            <el-radio :label="2" border >女</el-radio>
            <el-radio :label="3" border >不公开</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="年龄" prop="age" >  
          <el-input-number v-model="formData.age" :min="1" :max="100" label="输入年龄"></el-input-number>
        </el-form-item>

        <el-form-item label="工作经历" prop="works" >  
          <el-input type="textarea" v-model="formData.works" placeholder="输入工作经历"></el-input>
        </el-form-item>

        <el-form-item label="评语" prop="recommend_mark" >  
          <el-input type="textarea" v-model="formData.recommend_mark" placeholder="输入推荐评语"></el-input>
        </el-form-item>

        <el-form-item label="推荐星级" prop="assess" >  
          <el-rate
            v-model="formData.assess">
          </el-rate>
        </el-form-item>
        <el-form-item label="求职意向" prop="class_ids" >  
          <el-select v-model="formData.class_ids" placeholder="请选择" :multiple="true">
            <el-option-group
              v-for="(group,index) in classList"
              :key="group.value"
                :index="index+1+''" 
                :label="group.label"
            >
              <el-option
                v-for="item in group.children"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>

        <el-form-item label="推广费" prop="money" >  
          <el-input-number v-model="formData.money" :min="0" :max="100" label="价格"></el-input-number>
        </el-form-item>

     
      </el-form>

    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>


  </el-dialog>
</template>

<script>
import {setPopularizeApi,popularizeInfoApi } from  "@/api/relation/index.js";
import { getClassTree} from "@/api/director/job/index.js";


export default {
  components: { },

  data() {
    return {
      visible: false,
      pop_id:"",
      userList:[],
      classList:[],
      formData: {
          user_app_id:null,
          sex:1,
          type:1,
          age:0,
          works:"",
          recommend_mark:"",
          assess:1,
      },
       rules: {
        mobile: [
              {required: true, message: '请输入手机号', trigger: 'blur'}
          ],
       }
    };
  },

 
  mounted() {
    console.log("asdasdasd")

},
  
  methods: {
  
    handleClose() {
      this.$refs["form"].resetFields();
      this.visible = false;

    },


    init(pop_id) {
      this.visible = true;
      this.pop_id=pop_id;
      console.log(pop_id)
      this.initClassList();

      this.initInfo();
    },

    initInfo(){
      var that=this;
      popularizeInfoApi({pop_id:this.pop_id}).then((response) => {
              console.log(response);
              if(response.code==200){
                
                that.formData = response.data;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
    },

    initClassList(){
            var that = this;
            getClassTree({}).then((response) => {
                console.log(response);
                if(response.code==200){
                    that.classList = response.data;
                }
            });
        },
    
    
    submit(){
      var that=this;

      this.$refs["form"].validate((valid) => {
          if (valid) {
            setPopularizeApi(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'

                });
                that.$emit('refresh');
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });

    },

    
  },

 
};
</script>

<style lang="scss" scoped>



::v-deep .myWindow {
    border-radius: 15px;



/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }

  .table_form {
    width: 100%;
    height: 68px;
    box-sizing: border-box;
    border-radius: 6px;
    border: 1px solid #cccccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    margin-bottom: 19px;
  section {
    display: flex;
    img {
      width: 43px;
      height: 43px;
      margin-right: 15px;
    }
    div {
      height: 43px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      b {
        font-size: 16px;
        color: #333;
      }
      span {
        font-size: 11px;
        margin-right: 20px;
        color: #666;
      }
    }
  }
}
</style>
